import { Database } from './database.types.ts';

// Use this type to prettify the types that are unions of other types or interfaces
// EXAMPLE: type NiceReadableType = PrettifyType<SomeUnionType>
export type PrettifyType<T> = {
  [K in keyof T]: T[K];
} & unknown;

type DbOnboardingSessionPure =
  Database['public']['Tables']['onboarding_session']['Row'];

export type OnboardingSession = PrettifyType<DbOnboardingSessionPure>;

export enum ONBOARDING_STATUS {
  ONBOARDING_STARTED = 'onboarding_started',
  CALL_SCHEDULED = 'call_scheduled',
  CALL_ATTENDED = 'call_attended',
  NOT_INVESTING = 'not_investing',
  CONVERTED = 'converted',
  NOT_VALID = 'not_valid',
}

export enum OPERATOR_SPECIALTY {
  RETURNS = 'returns',
  DEDUCTIONS = 'deductions',
  LIQUIDITY = 'liquidity',
  BALANCED_RETURNS_DEDUCTIONS = 'balanced_returns_deductions',
  LOW_RISK = 'low_risk',
}

export enum FILING_STATUS {
  SINGLE = 'single',
  MARRIED_JOINT = 'married_joint',
  MARRIED_SEPARATE = 'married_separate',
  HEAD_HOUSEHOLD = 'head_household',
}

export const ONBOARDING_STATUS_OPTIONS = [
  ONBOARDING_STATUS.ONBOARDING_STARTED,
  ONBOARDING_STATUS.CALL_SCHEDULED,
  ONBOARDING_STATUS.CALL_ATTENDED,
  ONBOARDING_STATUS.NOT_INVESTING,
  ONBOARDING_STATUS.CONVERTED,
  ONBOARDING_STATUS.NOT_VALID,
] as const;

export const OPERATOR_SPECIALTY_OPTIONS = [
  OPERATOR_SPECIALTY.RETURNS,
  OPERATOR_SPECIALTY.DEDUCTIONS,
  OPERATOR_SPECIALTY.LIQUIDITY,
  OPERATOR_SPECIALTY.BALANCED_RETURNS_DEDUCTIONS,
  OPERATOR_SPECIALTY.LOW_RISK,
] as const;

export const FILING_STATUS_OPTIONS = [
  FILING_STATUS.SINGLE,
  FILING_STATUS.MARRIED_JOINT,
  FILING_STATUS.MARRIED_SEPARATE,
  FILING_STATUS.HEAD_HOUSEHOLD,
] as const;

//
